import script from "./LogoStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoStrip.vue?vue&type=script&setup=true&lang=js"

import "./LogoStrip.vue?vue&type=style&index=0&id=24d7514b&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d7514b"]])

export default __exports__